// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitle-full-div {
  width: 100%;
  height: 100%;
}

.subtitle-text-div {
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: text;
  outline: none;
}

.pl-5 {
  padding-left: 5px;
}

.pr-5 {
  padding-right: 5px;
}

.subtitle-text-div .foreCanvas {
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: text;
}

input[type='range'][orient='vertical'] {
  writing-mode: vertical-lr;
  direction: ltr;
  width: 16px;
  height: 100%;
  vertical-align: bottom;
}

.moving {
  cursor: grabbing;
}

.subtitle-timecodes-div {
  position: absolute;
  width: 100%;
  margin-top: 4em;
}

.subtitle-timecodes-div .col {

  color: #f5f5f5;
  height: 100%;
  font-size: 130%;
  margin: auto;
}

.subtitle-timecodes-div .col span {
   background-color: rgba(0, 0, 0, 0.5);
    border: 0.1em solid rgba(204, 204, 204, 0.5);
    border-radius: 0.5em;
}

.subtitle-timecodes-div .col.left {
  align-content: center;
  margin: 0;
  margin-left: 15px;
}

.subtitle-timecodes-div .col.left * {
  text-align: left;
  padding: 0 0.5em;
}

.subtitle-timecodes-div .col.center * {
  text-align: center;
  justify-content: center;
  align-content: center;
}
.subtitle-timecodes-div .col.center .timecode span {
  padding: 0 0.5em;
}

.subtitle-timecodes-div .col.right {
  align-content: center;
  margin: 0;
  margin-right: 15px;
}

.subtitle-timecodes-div .col.right * {
  justify-content: right;
  padding: 0 0.5em;
}

.subtitle-timecodes-div .row {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.subtitle-timecodes-div .timecode {
  margin-top: 0.25em;
}
.subtitle-timecodes-div .white,
.subtitle-timecodes-div .timecode .timecode-white,
.subtitle-timecodes-div .intervalles .intervalle-white {
  color: #f5f5f5;
}

.subtitle-timecodes-div .timecode .timecode-red,
.subtitle-timecodes-div .intervalles .intervalle-red {
  color: #fe5953;
  font-weight: 700;
}

.subtitle-timecodes-div .timecode .timecode-orange,
.subtitle-timecodes-div .intervalles .intervalle-orange {
  color: #f57c00;
  font-weight: 700;
}

.subtitle-timecodes-div .timecode.typing span {
  background-color: yellow;
  color: black !important;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitles/editsubtitle/edit-subtitle.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;GACG,oCAAoC;IACnC,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB","sourcesContent":[".subtitle-full-div {\n  width: 100%;\n  height: 100%;\n}\n\n.subtitle-text-div {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  cursor: text;\n  outline: none;\n}\n\n.pl-5 {\n  padding-left: 5px;\n}\n\n.pr-5 {\n  padding-right: 5px;\n}\n\n.subtitle-text-div .foreCanvas {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  cursor: text;\n}\n\ninput[type='range'][orient='vertical'] {\n  writing-mode: vertical-lr;\n  direction: ltr;\n  width: 16px;\n  height: 100%;\n  vertical-align: bottom;\n}\n\n.moving {\n  cursor: grabbing;\n}\n\n.subtitle-timecodes-div {\n  position: absolute;\n  width: 100%;\n  margin-top: 4em;\n}\n\n.subtitle-timecodes-div .col {\n\n  color: #f5f5f5;\n  height: 100%;\n  font-size: 130%;\n  margin: auto;\n}\n\n.subtitle-timecodes-div .col span {\n   background-color: rgba(0, 0, 0, 0.5);\n    border: 0.1em solid rgba(204, 204, 204, 0.5);\n    border-radius: 0.5em;\n}\n\n.subtitle-timecodes-div .col.left {\n  align-content: center;\n  margin: 0;\n  margin-left: 15px;\n}\n\n.subtitle-timecodes-div .col.left * {\n  text-align: left;\n  padding: 0 0.5em;\n}\n\n.subtitle-timecodes-div .col.center * {\n  text-align: center;\n  justify-content: center;\n  align-content: center;\n}\n.subtitle-timecodes-div .col.center .timecode span {\n  padding: 0 0.5em;\n}\n\n.subtitle-timecodes-div .col.right {\n  align-content: center;\n  margin: 0;\n  margin-right: 15px;\n}\n\n.subtitle-timecodes-div .col.right * {\n  justify-content: right;\n  padding: 0 0.5em;\n}\n\n.subtitle-timecodes-div .row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.subtitle-timecodes-div .timecode {\n  margin-top: 0.25em;\n}\n.subtitle-timecodes-div .white,\n.subtitle-timecodes-div .timecode .timecode-white,\n.subtitle-timecodes-div .intervalles .intervalle-white {\n  color: #f5f5f5;\n}\n\n.subtitle-timecodes-div .timecode .timecode-red,\n.subtitle-timecodes-div .intervalles .intervalle-red {\n  color: #fe5953;\n  font-weight: 700;\n}\n\n.subtitle-timecodes-div .timecode .timecode-orange,\n.subtitle-timecodes-div .intervalles .intervalle-orange {\n  color: #f57c00;\n  font-weight: 700;\n}\n\n.subtitle-timecodes-div .timecode.typing span {\n  background-color: yellow;\n  color: black !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
